export class RestaurantLocationDetails {
  address: string;
  zipCode: string;
  phone: string;
  email: string;
}
